<template>
  <div class="sidebar-container">
    <!-- Mobile Navbar -->
    <nav class="navbar navbar-mobile-toggle bg-white d-block d-lg-none">
      <div class="container-fluid py-2">
        <div class="d-flex cobrand-logo-container align-items-center">
          <img src="/img/logo_png/avid_logo_black.png" alt="Avid" class="logo" />
          <div
            v-if="(client && client.referring_agency && client.referring_agency_id !== 44) || (user && user.agency_id && user.agency_id !== 44)"
            class="mx-2 d-flex justify-content-center align-items-center">
            <span class="h3 mb-0 text-primary fw-normal">&</span>
          </div>
          <img v-if="client && client.referring_agency && client.referring_agency_id !== 44"
            :src="client.referring_agency.logo" class="navbar-brand-logo px-2">
          <img v-else-if="user && user.agency_id && user.agency_id !== 44 && user.agency" :src="user.agency.logo"
            class="navbar-brand-logo px-2">
        </div>
        <button class="navbar-toggler" type="button" @click="toggleMobileNav" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Open navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>

    <!-- Sidebar -->
    <div class="mega-nav-container">
      <div class="mega-nav" :style="megaNavStyle" :class="{ 'collapsed': if_collapsed && !if_mobile, 'show': if_mobile}" >
        <div class="navbar navbar-expand primary-tab-bar sidebar-toggle-btn d-none d-lg-flex">
          <div class="container-fluid">
            <div class="collapse navbar-collapse">
              <div class="btn-group toggle-btn-group" role="group">
                <button type="button" class="btn" @click="toggleSidebar"
                  :class="[if_collapsed ? 'btn-primary' : 'btn-white']" data-bs-toggle="tooltip" data-bs-placement="right"  title="Collapse sidebar">
                  <img src="/img/icons/avid-icons/list_collapsed.svg" class="icon" alt="">
                </button>
                <button type="button" class="btn" @click="toggleSidebar"
                  :class="[!if_collapsed ? 'btn-primary' : 'btn-white']" data-bs-toggle="tooltip" data-bs-placement="right" title="Expand sidebar">
                  <img src="/img/icons/avid-icons/list_expanded.svg" class="icon" alt="">
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mega-nav-inner">
          <div class="mega-nav-content" :class="{ 'needs-padding': needsPadding }">
            <ul
              class="nav nav-pills nav-flush flex-column flex-row flex-nowrap text-left align-items-left sidebar-nav my-2">
              <li v-if="if_mobile" class="nav-item">
                <org-select :user="user" :client="client" :clients="clients"></org-select>
              </li>
              <template v-if="((!client && !isRootPath) || (client && client.plan_level === 'benchmarks'))">
                <li class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pages/' + clientUrl + '/benchmarks'" 
                    :class="['nav-link nav-link-benchmark', { 'nav-link-active': isBenchmarksPageActive }]">
                    <img src="/img/icons/nav-icons/Benchmarks.svg" class="nav-logo me-3" alt="">
                    <span>Benchmarks</span>
                  </Link>
                  <Link v-else :href="'/pages/' + clientUrl + '/benchmarks'" class="text-center"
                      :class="['nav-link nav-link-benchmark', { 'nav-link-active': isBenchmarksPageActive }]"
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Benchmarks">
                    <img src="/img/icons/nav-icons/Benchmarks.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <li class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pages/' + clientUrl + '/scorecard'" 
                    :class="['nav-link nav-link-scorecard', { 'nav-link-active': isScorecardPageActive }]">
                    <img src="/img/icons/nav-icons/Scorecard.svg" class="nav-logo me-3" alt="">
                    <span>Scorecard</span>
                  </Link>
                  <Link v-else :href="'/pages/' + clientUrl + '/scorecard'"  class="text-center"
                    :class="['nav-link nav-link-scorecard', { 'nav-link-active': isScorecardPageActive }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Scorecard">
                    <img src="/img/icons/nav-icons/Scorecard.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <li class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pages/' + clientUrl + '/insights'" 
                    :class="['nav-link nav-link-insights', { 'nav-link-active': isInsightsPageActive }]">
                    <img src="/img/icons/nav-icons/Insights.svg" class="nav-logo me-3" alt="">
                    <span>Insights</span>
                  </Link>
                  <Link v-else :href="'/pages/' + clientUrl + '/insights'"  class="text-center"
                    :class="['nav-link nav-link-insights', { 'nav-link-active': isInsightsPageActive }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Insights">
                    <img src="/img/icons/nav-icons/Insights.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <li class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pages/' + clientUrl + '/pathways'" 
                    :class="['nav-link nav-link-pathways', { 'nav-link-active': isPathwaysPageActive }]">
                    <img src="/img/icons/nav-icons/Pathways.svg" class="nav-logo me-3" alt="">
                    <span>Pathways</span>
                  </Link>
                  <Link v-else :href="'/pages/' + clientUrl + '/pathways'"  class="text-center"
                    :class="['nav-link nav-link-pathways', { 'nav-link-active': isPathwaysPageActive }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Pathways">
                    <img src="/img/icons/nav-icons/Pathways.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <li class="nav-item" v-if="clientUrl === 'demo'">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pages/' + clientUrl + '/lockstep'" 
                    :class="['nav-link nav-link-locks', { 'nav-link-active': isLockStepPageActive }]">
                    <img src="/img/icons/nav-icons/LockStep.svg" class="nav-logo me-3" alt="">
                    <span>LockStep</span>
                  </Link>
                  <Link v-else :href="'/pages/' + clientUrl + '/lockstep'"  class="text-center"
                    :class="['nav-link nav-link-locks', { 'nav-link-active': isLockStepPageActive }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="LockStep">
                    <img src="/img/icons/nav-icons/LockStep.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>
              </template>

              <!-- Client Navigation -->
              <template v-else>
                <!-- <li v-if="client && client.url" class="nav-item">
                  <a v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="dashboardUrl" 
                    :class="['nav-link nav-link-dashboard', { 'nav-link-active': isDashboardRoute }]" >
                    <img src="/img/icons/nav-icons/Dashboard.svg" class="nav-logo me-3">
                    <span>Dashboard</span>
                  </a>

                  <a v-else :href="dashboardUrl"  class="text-center"
                      :class="['nav-link nav-link-dashboard', { 'nav-link-active': isDashboardRoute }]" 
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Dashboard">
                    <img src="/img/icons/nav-icons/Dashboard.svg" class="nav-logo me-0">
                  </a>
                </li> -->

                <!-- Insights Level Features -->
                <template v-if="client && client.url && (client.plan_level === 'insights' || client.plan_level === 'trial')">
                  <li class="nav-item" v-if="canView('scorecard')">
                    <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/scorecard/' + client.url" 
                      :class="['nav-link nav-link-scorecard', { 'nav-link-active': isRoute('view_scorecard_page') }]">
                      <img src="/img/icons/nav-icons/Scorecard.svg" class="nav-logo me-3" alt="">
                      <span>Scorecard</span>
                    </Link>
                    <Link v-else :href="'/scorecard/' + client.url"  class="text-center"
                      :class="['nav-link nav-link-scorecard', { 'nav-link-active': isRoute('view_scorecard_page') }]"
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Scorecard">
                      <img src="/img/icons/nav-icons/Scorecard.svg" class="nav-logo me-0" alt="">
                    </Link>
                  </li>

                  <!-- Playbooks -->
                  <li class="nav-item" v-if="canView('playbooks')">
                    <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/playbooks/' + client.url + '/list'" 
                    :class="['nav-link nav-link-playbooks', { 'nav-link-active': isPlaybooksRoute }]">
                      <img src="/img/icons/nav-icons/Playbooks.svg" class="nav-logo me-3 nav-white" alt="">
                      <span class="me-2 pe-1">Playbooks</span>
                    </Link>
                    <Link v-else :href="'/playbooks/' + client.url + '/list'" class="text-center"
                    :class="['nav-link nav-link-playbooks', { 'nav-link-active': isPlaybooksRoute }]"
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Playbooks">
                      <img src="/img/icons/nav-icons/Playbooks.svg" class="nav-logo me-0 nav-white" alt="">
                    </Link>
                  </li>

                  <li class="nav-item" v-if="canView('insights')">
                    <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/insights/' + client.url" 
                      :class="['nav-link nav-link-insights', { 'nav-link-active': isInsightsRoute }]">
                      <img src="/img/icons/nav-icons/Insights.svg" class="nav-logo me-3" alt="">
                      <span>Insights</span>
                    </Link>
                    <Link v-else :href="'/insights/' + client.url"  class="text-center"
                      :class="['nav-link nav-link-insights', { 'nav-link-active': isInsightsRoute }]"
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Insights">
                      <img src="/img/icons/nav-icons/Insights.svg" class="nav-logo me-0" alt="">
                    </Link>
                  </li>
                </template>

                <!-- Benchmarks -->
                <li v-if="client && client.url && canView('benchmarks')" class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/benchmarks/' + client.url + '/dashboard'" 
                    :class="['nav-link nav-link-benchmark', { 'nav-link-active': isRoute('view_generic_wiland_benchmark_dashboard') || isRoute('view_generic_wiland_benchmark_section') || isRoute('view_wiland_benchmark_dashboard_page') || isRoute('view_wiland_benchmark_page_section') }]" >
                    <img src="/img/icons/nav-icons/Benchmarks.svg" class="nav-logo me-3" alt="">
                    <span>Benchmarks</span>
                  </Link>

                  <Link v-else :href="'/benchmarks/' + client.url + '/dashboard'"  class="text-center"
                      :class="['nav-link nav-link-benchmark', { 'nav-link-active': isRoute('view_generic_wiland_benchmark_dashboard') || isRoute('view_generic_wiland_benchmark_section') || isRoute('view_wiland_benchmark_dashboard_page') || isRoute('view_wiland_benchmark_page_section') }]" 
                      data-bs-toggle="tooltip" data-bs-placement="right" title="Benchmarks">
                    <img src="/img/icons/nav-icons/Benchmarks.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <!-- Pathways -->
                <li class="nav-item" v-if="client && client.url && client.census_api_key && (client.plan_level === 'insights' || client.plan_level === 'trial') && canView('pathways')">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/pathways/' + client.url + '/push_audience'" 
                    :class="['nav-link nav-link-pathways', { 'nav-link-active': isPathwaysRoute }]">
                    <img src="/img/icons/nav-icons/Pathways.svg" class="nav-logo me-3" alt="">
                    <span>Pathways</span>
                  </Link>
                  <Link v-else-if="client && client.url != 'demo'" :href="'/pathways/' + client.url + '/push_audience'" class="text-center"
                    :class="['nav-link nav-link-pathways', { 'nav-link-active': isPathwaysRoute }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Pathways">
                    <img src="/img/icons/nav-icons/Pathways.svg" class="nav-logo me-0" alt="">
                  </Link>
                </li>

                <!-- Direct Mail -->
                <li v-if="client && client.url && showDirectMail()" class="nav-item">
                  <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/direct_mail/' + client.url + '/appeals'" 
                    :class="['nav-link nav-link-directmail', { 'nav-link-active': isRoute('direct_mail') }]">
                    <img src="/img/icons/nav-icons/DirectMail.svg" class="nav-logo me-3 nav-white" alt="">
                    <span>Direct Mail</span>
                  </Link>
                  <Link v-else :href="'/direct_mail/' + client.url + '/appeals'" class="text-center"
                    :class="['nav-link nav-link-directmail', { 'nav-link-active': isRoute('direct_mail') }]"
                    data-bs-toggle="tooltip" data-bs-placement="right" title="Direct Mail">
                    <img src="/img/icons/nav-icons/DirectMail.svg" class="nav-logo me-0 nav-white" alt="">
                  </Link>
                </li>

              </template>

              <!-- Lockstep -->
              <li v-if="client && client.url && client.url != 'demo'" class="nav-item">
                <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/lockstep/' + client.url" 
                  :class="['nav-link nav-link-support', { 'nav-link-active': isRoute('view_lockstep_page') }]">
                  <img src="/img/icons/nav-icons/LockStep.svg" class="nav-logo me-3" alt="LockStep">
                  <span>LockStep</span>
                </Link>
                <Link v-else-if="client && client.url != 'demo'" :href="'/lockstep/' + client.url" class="text-center"
                  :class="['nav-link nav-link-support', { 'nav-link-active': isRoute('view_lockstep_page') }]"
                  data-bs-toggle="tooltip" data-bs-placement="right" title="LockStep">
                  <img src="/img/icons/nav-icons/LockStep.svg" class="nav-logo me-0" alt="LockStep">
                </Link>
              </li>

              <!-- Notifications -->
              <li class="nav-item">
                <a v-if="!if_collapsed || (if_collapsed && if_mobile)" class="nav-link notification-trigger" href="#" @click.prevent.stop="toggleNotificationDropdown">
                  <img src="/img/icons/nav-icons/Notifications.svg" class="nav-logo me-3" alt="">
                  <span>Notifications</span>
                  <span v-if="notif != null && notif.length > 0" class="notification-badge rounded-pill badge bg-danger">
                      {{ num_abbr_wo_float(num_notifications) }}
                  </span>
                </a>
                <a v-else class="nav-link text-center notification-trigger" href="#" @click.prevent.stop="toggleNotificationDropdown">
                  <div class="position-relative">
                    <img src="/img/icons/nav-icons/Notifications.svg" class="nav-logo me-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Notifications" alt="">
                    <span v-if="num_notifications > 0" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                      <span class="visually-hidden">New notifications</span>
                    </span>
                  </div>
                </a>
              </li>

              <!-- Profile simplified: direct link based on user role -->
              <li class="nav-item" v-if="client && client.url != 'demo'">
                <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="profileUrl"
                  :class="['nav-link nav-link-profile', { 'nav-link-active': isAdminRoute }]">
                  <img src="/img/icons/nav-icons/Profile.svg" class="nav-logo me-3" alt="">
                  <span>Profile</span>
                </Link>
                <Link v-else-if="client && client.url != 'demo'" :href="profileUrl" class="text-center"
                  :class="['nav-link nav-link-profile', { 'nav-link-active': isAdminRoute }]"
                  data-bs-toggle="tooltip" data-bs-placement="right" title="Profile">
                  <img src="/img/icons/nav-icons/Profile.svg" class="nav-logo me-0" alt="">
                </Link>
              </li>

              <!-- Settings -->
              <li v-if="client && client.url && client.url != 'demo' && (canView('settings') || canView('connections') || canView('billing'))" class="nav-item">
                <Link v-if="!if_collapsed || (if_collapsed && if_mobile)" :href="'/settings/' + client.url + '/profile'" 
                  :class="['nav-link nav-link-settings', { 'nav-link-active': isRoute('settings_client') }]">  
                  <img src="/img/icons/nav-icons/Settings.svg" class="nav-logo me-3 nav-white" alt="">
                  <span>Settings</span>
                </Link>
                <Link v-else :href="'/settings/' + client.url + '/profile'" class="text-center"
                  :class="['nav-link nav-link-settings', { 'nav-link-active': isRoute('settings_client') }]"
                  data-bs-toggle="tooltip" data-bs-placement="right" title="Settings">  
                  <img src="/img/icons/nav-icons/Settings.svg" class="nav-logo me-0 nav-white" alt="">
                </Link>
              </li>
            </ul>

            
            
            <!-- Mobile Logout Button - Fixed at bottom of screen -->
            <div v-if="if_mobile" class="position-fixed bottom-0 start-0 w-100 bg-white border-top p-3" style="z-index: 1040;">
              <Link href="/logout" method="post" class="btn btn-secondary w-100">
                <i class="fa fa-sign-out me-2"></i>Log out
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- New Notification Dropdown -->
    <notification-dropdown :notifications="notif" :is-open="showNotificationDropdown"
      :is-sidebar-collapsed="if_collapsed" :is-mobile="if_mobile" :is-loading="isLoadingNotifications"
      :is-loading-more="isLoadingMoreNotifications" :has-more="hasMoreNotifications"
      @close="closeNotificationDropdown" @mark-all-read="dismissAll"
      @mark-read="dismiss" @filter-changed="handleFilterChange" @load-more="loadMoreNotifications"></notification-dropdown>
  </div>
</template>

<script>
import vSelect from 'vue3-select'
import statsigService from '../../services/statsig'
import permissionsMixin from '../../mixins/permissions'
import { useNotifications } from '../../composables/useNotifications';

export default {
  name: 'Sidebar',
  
  components: {
    vSelect
  },

  mixins: [permissionsMixin],
  setup() {
    const { showNotification } = useNotifications();
    return {
      showNotification
    };
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      default: null
    },
    clients: {
      type: Array,
      required: true
    },
    currentRoute: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      if_collapsed: true,
      if_mobile: false,
      local_clients: [],
      local_client: null,
      notif: null,
      showNotificationDropdown: false,
      isLoadingNotifications: false,
      isLoadingMoreNotifications: false,
      hasMoreNotifications: false,
      currentNotificationPage: 1,
      currentNotificationSort: 'by-date-newest',
      form: {
          category: '',
          urgency: '',
          title: '',
          description: ''
      },
      errors: {
          category: '',
          title: '',
          description: '',
          urgency: ''
      },
      working: false,
      search_key: '',

      statsigReady: false,

      hasCheckedDirectMailGate: false,
      directMailGateResult: null,
      hasCheckedPlanningGate: false,
      planningGateResult: null,

      // NEW: dynamic top offset for sidebar
      initialTop: 85,
      navTop: 85,
      scrollContainer: null,
      needsPadding: false,
    }
  },

  async mounted() {
    // Initialize tooltips after component is mounted
    this.$nextTick(() => {
      this.initializeTooltips();
      this.checkNavPadding();
    });

    // Add click outside listener for notification dropdown
    document.addEventListener('click', this.handleClickOutside);

    try {
      await statsigService.initialize(this.user)
      this.directMailGateResult = statsigService.checkGate('direct_mail_access')
      this.planningGateResult = statsigService.checkGate('planning_access')

      this.hasCheckedDirectMailGate = true
      this.hasCheckedPlanningGate = true

    } catch (err) {
      console.error('Statsig failed to init, defaulting gates on:', err)
      this.directMailGateResult = true
      this.planningGateResult = false
      this.hasCheckedDirectMailGate = true
      this.hasCheckedPlanningGate = true
    } finally {
      this.statsigReady = true
    }
    window.addEventListener('scroll', this.updateNavPosition)
    // Determine scroll container (main content div if exists, else window)
    this.scrollContainer = document.querySelector('.main-content') || window
    this.scrollContainer.addEventListener('scroll', this.updateNavPosition)
    window.addEventListener('resize', this.checkNavPadding)
  },

  beforeUnmount() {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('scroll', this.updateNavPosition)
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.updateNavPosition)
    }
  },

  beforeMount() {
    // org selector logic has moved to OrgSelect component
    // Notifications will be loaded via API when dropdown opens
    this.notif = [];
  },

  computed: {
    clientUrl() {
      if (!this.client || !this.client.url) {
        return 'demo';
      }
      return this.client.url;
    },
    // dashboardUrl() {
    //   // Priority: selected client -> agency dashboard -> admin dashboard
    //   if (this.client && this.client.url) {
    //     // A client is selected in OrgSelect; navigate to the client's dashboard
    //     return `/dashboard/client/${this.client.url}`;
    //   }
    //   if (this.user && this.user.user_type === 'agency_admin') {
    //     return `/dashboard/agency/${this.user.agency_id}`;
    //   }
    //   if (this.user && this.user.user_type === 'admin') {
    //     return '/admin';
    //   }
    //   return '#';
    // },
    profileUrl() {
      // if (this.user && this.user.user_type === 'admin') {
      //   return '/admin';
      // }
      if (this.client && this.client.url) {
        return `/user/${this.client.url}/profile`;
      }
      if (this.user && this.user.user_type === 'agency_admin') {
        return '/admin/agency/profile';
      }
      return '#';
    },
    planUrl() {
      if (!this.client || !this.client.active_plan) return '';
      return this.client.active_plan.url;
    },
    // isDashboardRoute() {
    //   if (this.user && this.user.user_type === 'admin') {
    //     return this.isRoute('admin_dashboard') || this.currentRoute.includes('/admin');
    //   }
    //   if (this.user && this.user.user_type === 'agency_admin') {
    //     return this.isRoute('agency_dashboard') || this.currentRoute.includes(`/dashboard/agency/${this.user.agency_id}`);
    //   }
    //   if (this.client && this.client.url) {
    //     return this.isRoute('client_dashboard') || this.currentRoute.includes(`/dashboard/client/${this.client.url}`);
    //   }
    //   return false;
    // },
    isInsightsRoute() {
      return ['insight_dashboard', 'insights_landing', 'view_insights_page', 'view_insights_page_section', 'view_ppt_generate_page']
        .some(route => this.isRoute(route));
    },
    isPathwaysRoute() {
      return ['view_pathways', 'push_audience_to_pathways', 'view_pathways_mapping', 'create_pathways_segment', 'update_pathways_segment']
        .some(route => this.isRoute(route));
    },
    isResultsRoute() {
      if (!this.currentRoute) return false;
      return this.currentRoute.includes('results');
    },
    isPlanningRoute() {
      if (!this.currentRoute) return false;
      return this.currentRoute.includes('planning');
    },
    isPlaybooksRoute() {
      if (!this.currentRoute) return false;
      return this.currentRoute.includes('experiment') || this.currentRoute.includes('playbook');
    },
    isAdminRoute() {
      return ['admin_client', 'admin_user', 'admin_agency', 'admin_agency_user', 'admin_agency_client',
        'admin_agency_client_results', 'create_notification', 'playbook_type_list', 'admin_initiative_editor',
        'metric_filter_list', 'chart_list', 'chart_list_filtered', 'view_chart', 'report_builder_list',
        'report_builder_list_client', 'report_builder_list_filter', 'report_builder', 'report_builder_new',
      ].some(route => this.isRoute(route));
    },
    num_notifications() {
      // Use count from user if available, otherwise fallback to loaded notifications length
      return this.user?.unread_notifications_count ?? this.notif.length;
    },
    isBenchmarksPageActive() {
      return window.location.pathname === `/pages/${this.clientUrl}/benchmarks`;
    },
    isScorecardPageActive() {
      return window.location.pathname === `/pages/${this.clientUrl}/scorecard`;
    },
    isInsightsPageActive() {
      return window.location.pathname === `/pages/${this.clientUrl}/insights`;
    },
    isPathwaysPageActive() {
      return window.location.pathname === `/pages/${this.clientUrl}/pathways`;
    },
    isLockStepPageActive() {
      return window.location.pathname === `/pages/${this.clientUrl}/lockstep`;
    },
    isRootPath() {
      if (typeof window === 'undefined') return false;
      return window.location.pathname === '/';
    },
    megaNavStyle() {
      // Only apply on desktop view (not mobile view when .show is active)
      if (this.if_mobile) return {}
      return {
        top: this.navTop + 'px',
        height: `calc(100vh - ${this.navTop}px)`
      }
    }
  },

  watch: {
    statsigReady(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initializeTooltips();
        });
      }
    }
  },

  methods: {
    showResults() {
      // Wait until Statsig has finished initializing before displaying Results
      if (!this.statsigReady) {
        return false;
      }
      if (!this.checkPlanningGate()) {
        return false;
      }

      if (!this.client) return false;
      return this.client.published_plan;
    },
    showPlanning() {
      // Wait until Statsig has finished initializing before displaying Planning
      if (!this.statsigReady) {
        return false;
      }
      // Check the Statsig feature gate first
      if (!this.checkPlanningGate()) {
        return false;
      }
      // Check if user has planning permissions
      if (!this.canView('insights')) {
        return false;
      }

      // If the feature gate is enabled and user has permissions, use the original logic
      return this.client && this.client.url;
    },
    showDirectMail() {
      // Wait until Statsig has finished initializing before displaying Direct Mail
      if (!this.statsigReady) {
        return false;
      }
      // Check the Statsig feature gate first
      if (!this.checkDirectMailGate()) {
        return false;
      }

      // Check if user has direct_mail permissions
      if (!this.canView('direct_mail')) {
        return false;
      }

      // If the feature gate is enabled and user has permissions, use the original logic
      return (this.client && this.client.url &&
             (this.client.plan_level === 'insights' || this.client.plan_level === 'trial'));
    },
    // Add the initializeTooltips method
    initializeTooltips() {
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
      for (var i = 0; i < tooltipTriggerList.length; i++) {
        (function(index) {
          tooltipTriggerList[index].addEventListener('click', function() {
            // Hide the tooltip using the index passed to the closure
            tooltipList[index].hide();
          });
          tooltipTriggerList[index].addEventListener('mouseleave', function() {
            // Hide the tooltip using the index passed to the closure
            tooltipList[index].hide();
          });
        })(i);
      }
    },
    handleResize() {
      this.if_collapsed = window.innerWidth <= 767;
    },
    isRoute(routeName) {
      if (!this.currentRoute) return false;
      return this.currentRoute === routeName;
    },
    route(name, params = []) {
      if (!this.client || !this.client.url) return '#';
      // This is a placeholder - you'll need to implement proper route generation
      return `/${name}/${params.join('/')}`;
    },
    toggleSidebar() {
      this.if_collapsed = !this.if_collapsed;
      window.dispatchEvent(new Event('sidebar-toggle'));
      // Re-initialize tooltips after sidebar state changes
      this.$nextTick(() => {
        this.initializeTooltips();
        this.checkNavPadding();
      });
    },
    toggleMobileNav() {
      this.if_mobile = !this.if_mobile;
      // Re-initialize tooltips after mobile nav toggle
      this.$nextTick(() => {
        this.initializeTooltips();
        this.checkNavPadding();
      });
    },
    checkNavPadding() {
      this.$nextTick(() => {
        const el = this.$el;
        if (!el || typeof el.querySelector !== 'function') {
          return;
        }
        const content = el.querySelector('.mega-nav-content');
        if (content) {
          this.needsPadding = content.scrollHeight > content.clientHeight;
        }
      });
    },
    // org selector logic has moved to OrgSelect component
    markRead(n) {
      this.dismiss(n);
      document.location = n.data['url'];
    },
    dismiss(n) {
      // Mark notification as fading out
      const notification = this.notif.find(notif => notif.id === n.id);
      if (notification) {
        notification._fadingOut = true;
      }
      
      window.axios.get('/api/notification/read/' + n.id).then(() => {
        // Wait for fade animation to complete before removing
        setTimeout(() => {
          //Remove the notification from the list
          for(var i = 0; i < this.notif.length; i++) {
            if(this.notif[i].id === n.id) {
              this.notif.splice(i, 1);
              break;
            }
          }
          // Update the count on the user object
          if (this.user && this.user.unread_notifications_count > 0) {
            this.user.unread_notifications_count--;
          }
        }, 300); // Match CSS transition duration
      });
    },
    dismissAll() {
      window.axios.get('/api/notification/read_all').then(() => {
        //Remove all the notification from the list
        this.showNotification({
          text: 'Your notifications were cleared.',
          icon: '/img/icons/nav-icons/Notifications.svg'
          
        });
        this.notif = [];
        // Update the count on the user object
        if (this.user) {
          this.user.unread_notifications_count = 0;
        }
        this.closeNotificationDropdown();
      });
    },
    async toggleNotificationDropdown() {
      const wasOpen = this.showNotificationDropdown;
      this.showNotificationDropdown = !this.showNotificationDropdown;
      
      // If opening the dropdown, fetch notifications (reset pagination)
      if (!wasOpen && this.showNotificationDropdown) {
        this.currentNotificationPage = 1;
        this.currentNotificationSort = 'by-date-newest';
        await this.fetchNotifications(true);
      }
    },
    async fetchNotifications(reset = true) {
      if (reset) {
        this.isLoadingNotifications = true;
        this.currentNotificationPage = 1;
        this.notif = [];
      } else {
        this.isLoadingMoreNotifications = true;
      }
      
      try {
        const response = await window.axios.get('/api/notification/', {
          params: {
            page: this.currentNotificationPage,
            per_page: 25,
            sort_by: this.currentNotificationSort
          }
        });
        
        const newNotifications = response.data.notifications || [];
        
        if (reset) {
          this.notif = newNotifications;
        } else {
          this.notif = [...this.notif, ...newNotifications];
        }
        
        this.hasMoreNotifications = response.data.has_more || false;
        this.currentNotificationPage++;
      } catch (error) {
        console.error('Error fetching notifications:', error);
        if (reset) {
          this.notif = [];
        }
      } finally {
        this.isLoadingNotifications = false;
        this.isLoadingMoreNotifications = false;
      }
    },
    async loadMoreNotifications() {
      if (!this.isLoadingMoreNotifications && this.hasMoreNotifications) {
        await this.fetchNotifications(false);
      }
    },
    handleFilterChange(sortBy) {
      this.currentNotificationSort = sortBy;
      this.fetchNotifications(true);
    },
    closeNotificationDropdown() {
      this.showNotificationDropdown = false;
    },
    handleClickOutside(event) {
      // Close notification dropdown if clicking outside
      if (this.showNotificationDropdown) {
        const notificationDropdown = this.$el.querySelector('.notification-dropdown');
        const notificationButtons = this.$el.querySelectorAll('.notification-trigger');
        
        // Check if click is on any notification button
        let clickedButton = false;
        notificationButtons.forEach(button => {
          if (button.contains(event.target)) {
            clickedButton = true;
          }
        });
        
        if (notificationDropdown && !notificationDropdown.contains(event.target) && !clickedButton) {
          this.closeNotificationDropdown();
        }
      }
    },
    emitInput() {
      this.$emit('input', this.data_filter);
    },

    checkDirectMailGate() {
      // If we've already checked the gate, return the cached result
      if (this.hasCheckedDirectMailGate) {
        return this.directMailGateResult;
      }

      // Mark that we've checked the gate
      this.hasCheckedDirectMailGate = true;

      try {
        // Check the direct_mail_access feature gate using the service
        const hasAccess = statsigService.checkGate('direct_mail_access');

        // Cache the result
        this.directMailGateResult = hasAccess;

        return hasAccess;
      } catch (error) {
        // If there's an error, fall back to the default logic
        this.directMailGateResult = true;
        return true;
      }
    },

    checkPlanningGate() {
      // If we've already checked the gate, return the cached result
      if (this.hasCheckedPlanningGate) {
        return this.planningGateResult;
      }

      // Mark that we've checked the gate
      this.hasCheckedPlanningGate = true;

      try {
        // Check the planning_access feature gate using the service
        const hasAccess = statsigService.checkGate('planning_access');

        // Cache the result
        this.planningGateResult = hasAccess;

        return hasAccess;
      } catch (error) {
        // If there's an error, fall back to the default logic
        this.planningGateResult = true;
        return true;
      }
    },
    updateNavPosition() {
      if (window.innerWidth < 992) return // desktop only
      const scrollY = this.scrollContainer === window ? (window.scrollY || window.pageYOffset) : this.scrollContainer.scrollTop
      const newTop = this.initialTop - scrollY
      if (newTop < 30) {
        this.navTop = 30
      } else if (newTop > this.initialTop) {
        this.navTop = this.initialTop
      } else {
        this.navTop = newTop
      }

      // recalc padding need on scroll as viewport height may change relative to content
      this.checkNavPadding();
    },
  }
}
</script>
